<template>
	<div>
		<main role="main" style="padding-top: 0px;">
			<div class="container-fluid right_wrapper">
				<AccountsHeader
					@exportExcel="exportExcel"
					@filterList="searchAccList"
					:isExportExcel="isExportExcel"
					@getAccountList = "getAccountList"
				/>
				<div class="spinner-border" style="margin:auto;display:block;margin-top:60px" v-if="loader"/>
				<div v-else>
					<div v-if = "(list && list.length) ||(accountList && accountList.length>0)">
						<AccountsListGrid
							:isExportExcel="isExportExcel"
							@filterList="searchAccList"
							@fileImported="fileImported"
							class="table_wrap"
						/>
						<AccountsListFooter @filterList="searchAccList" v-if="accountList.length>0" class="main_footer_wrap"/>
					</div>
					<div v-else>
						<NoDataAvailable displayMessage="No Data Is Available" ></NoDataAvailable>
					</div>

				</div>
			</div>
		</main>
	</div>
</template>


<script>
	import AccountsHeader from "@/components/account-management/AccountsHeader"
	import AccountsListGrid from "@/components/account-management/AccountsListGrid"
	import AccountsListFooter from "@/components/account-management/AccountsListFooter"
	import NoDataAvailable from '@/components/NoDataAvailable.vue'


	export default {
		name: "AccountList",
		data() {
			return {
				loader: false,
				isExportExcel: false,
				availableSorts:['client_name','go_retail','go_marketing','go_ops','go_dsp','no_of_profile','no_of_vendor','no_of_seller','no_of_dsp','date_created'],
				list:[]
			};
		},
		components: {
			AccountsHeader,
			AccountsListGrid,
			AccountsListFooter,
			NoDataAvailable
		},
		beforeMount(){
			function parseJwt (token) {
				var base64Url = token.split('.')[1];
				var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
				var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
					return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
				}).join(''));

				return JSON.parse(jsonPayload);
			};	
			// console.log('Session data : ',localStorage.getItem('session'));

			let jwtToken = JSON.parse(localStorage.getItem('session')).idToken;
			jwtToken = parseJwt(jwtToken)
			let hasUserPool = jwtToken["cognito:groups"] ? jwtToken["cognito:groups"].filter(x=>x.toLowerCase()=="gkclientaccountadministrators") : [];
			if(jwtToken["cognito:groups"] && hasUserPool && hasUserPool.length){
				this.$store.commit('setisUserAdmin', true)
			}
			else{
				this.$store.commit('setisUserAdmin', false)
			}
		},
		mounted() {
			this.$store.dispatch("callAnalytics", {data:window.location.href, this:this, type:'accountsList'})
			if(this.$store.state.calledFromCancel){
				if(this.$store.state.selectedSortOrder && this.$store.state.selectedSortOrder.field!='name'){
					this.sort = this.$store.state.selectedSortOrder
				}
				else{
					this.sort = {
					field:'date_created',
					order:'desc'
					}
				}
				this.$store.state.calledFromCancel = false
			}
			else{
				var retainSort = -1
				retainSort = this.availableSorts.findIndex(item=> item==this.sort.field)
				if(retainSort>-1){
					this.sort = this.$store.state.selectedSortOrder
					this.getAccountList()
				}
				else{
					this.sort = {
						field:'date_created',
						order:'desc'
					}
				}

				this.getVendorList()
				this.getClientList()
			}
		},
		watch: {
			sort() {
				if(this.$store.state.calledFromCancel == false){
					this.getAccountList();
				}
				else{
					this.$store.state.calledFromCancel = false
				}
			}
		},
		computed:{
			sort: {
				set(val) {
					this.$store.commit("setSelectedSortOrder", val)
				},
				get() {
					return this.$store.state.selectedSortOrder
				}
			},
			accountList:{
				set(val) {
					this.$store.commit("accounts/updateAccountList", val)
				},
				get() {
					return this.$store.getters["accounts/getAccountList"]
				}
			}
		},
		beforeDestroy() {
			if(this.$route.name!='accountDetails' && this.$route.name != 'addVendor'){
				this.sort = {
					field: "name",
					order: "asc"
				}
			}
		},
		methods: {
			getAccountList() {
				this.loader = true
				const vm = this
				this.$store.dispatch("accounts/checkIfUpdating")
				vm.$store.dispatch("accounts/getAccountList").then(res => {
					 vm.list = res
					 vm.loader = false
				})
			},
			searchAccList() {
				this.getAccountList()
			},
			getVendorList() {
				this.$store.dispatch("getAllVendor")
			},
			getClientList(){
				this.$store.dispatch("getAccountClient")
			},
			exportExcel() {
				this.isExportExcel = true
			},
			fileImported() {
				this.isExportExcel = false
			}
		}
	}
</script>
